// extracted by mini-css-extract-plugin
module.exports = {"currentVin":"_2U2VjkGLsBjS9jjAl5qOsM"};